export const jpcorpConfig = {
    taxOfficeName: 'Tax Office',
    deliveryTaxOfficeQuestionTag: 'GOV',
    searchPlaceholder: "Search projects using names or ID numbers...",
    taxId: "Entity ID",
    atlasId: "Entity ID",
    yearLabel: "Year",
    gtsId: null,
    entityPrimaryName: "Entity Name",
    entitySecondaryName: "Additional Names",
    entityPrimaryNamePlaceholder: "Entity Name",
    entitySecondaryNamePlaceholder: "",
    clientAlias: "Client Group",
    populationAlias: "Population",
    taxpayerAlias: "Entity",
    taxReturnAlias: "Project Form",
    taxpayerAliasPath: "projects",
    taxReturnAliasPath: "project-forms",
    countryAlias: "Business Unit",
    smartFormAlias: "Smart Form",
    otSyncStatus: "OneTeam Sync"
};
